// resources/js/store/reducers/LeftPanelReducer.js

const initialeState = {
    showCurrentTab : 'geoData',
    showCurrentSection: 'map',
    showCenterSection: null,
    showDetailParcelle: false,
    detailKeyPar : null,
    detailLot : null,
    idLocal : null,
    showDataPanel: false,
    showLayerPanel: false,
    showSearchTools: false,
    showLibrairiePanel: false,
    showResources: false,
    showFloatingDataPanel: false,
    showFloatingLibraryPanel: false,
    leftNavWidth: 0,
    leftPanelOpen: false,
    leftMenuIsOpen: true,
    showDetailData: false,
    showPricing: false,
}

const LeftPanelReducer = (state = initialeState, action) => {
    switch (action.type) {
        case 'TOGGLE_PANEL_TAB':
            return {
                ...state,
                showCurrentTab: action.data.currentTab
            };
        case 'TOGGLE_SHOW_DETAIL_PARCELLE':
            return {
                ...state,
                showDetailParcelle: action.data.showDetailParcelle,
                detailKeyPar: action.data.keypar,
            };
        case 'TOGGLE_DETAIL_LOT':
            return {
                ...state,
                detailLot: action.data.currentLot,
            };
        case 'SET_ID_LOCAL':
            return {
                ...state,
                idLocal: action.data.idLocal
            };
        case 'SHOW_SEARCH_PANEL':
            return {
                ...state,
                showSearchTools: action.data,
                leftPanelOpen: false,
                showCurrentSection: action.data ? "search" : "none",
            };
        case 'TOGGLE_FLOATING_DATA_PANEL':
            return {
                ...state,
                showFloatingDataPanel: !state.showFloatingDataPanel
            };
        case 'SHOW_CURRENT_SECTION':
            return {
                ...state,
                showCurrentSection: action.data,
                showCenterSection: false,
                showSearchTools: false
            };
        case 'SHOW_CENTER_SECTION':
            return {
                ...state,
                showCenterSection: action.data
            };
        case 'SHOW_DATA_PANEL':
            return {
                ...state,
                showDataPanel: action.data
            };
        case 'SHOW_LAYERS_PANEL':
            return {
                ...state,
                showLayerPanel: action.data
            };
        case 'SHOW_LIBRAIRIE_PANEL':
            return {
                ...state,
                showLibrairiePanel: action.data
            };
        case 'SHOW_FLOATING_DATA_PANEL':
            return {
                ...state,
                showFloatingDataPanel: action.data
            };
        case 'SHOW_FLOATING_LIBRARY_PANEL':
            return {
                ...state,
                showFloatingLibraryPanel: action.data
            };
        case 'SET_LEFT_PANEL_OPEN':
            return {
                ...state,
                leftPanelOpen: action.data,
            };
        case 'SET_LEFT_MENU_OPEN':
            return {
                ...state,
                leftNavWidth: action.data ? 10 : 0,
                leftMenuIsOpen: !state.leftMenuIsOpen,
            };
        case 'SHOW_DETAIL_PANEL_DATA':
            return {
                ...state,
                showDetailData: action.data
            };
        case 'SET_LEFT_PANEL_WIDTH':
            return {
                ...state,
                leftNavWidth: action.data
            };
        case 'SET_SHOW_PRICING':
            return {
                ...state,
                showPricing: action.data
            };
        default:
            return state;
    }
}

export default LeftPanelReducer;
